import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { siteConfig } from '../data/siteConfig';
export function GuaranteeSection() {
  return <section className="bg-mist py-16 lg:py-20" data-id="element-47" data-mp="4vjn44ww56f5">
      <div className="mx-auto flex max-w-3xl flex-col items-center gap-6 px-5 text-center sm:flex-row sm:items-start sm:text-left" data-id="element-48" data-mp="9ttgc9z21wy4">
        <div className="flex h-24 w-24 shrink-0 flex-col items-center justify-center rounded-full border-4 border-aqua bg-white" data-id="element-49" data-mp="ev0sel88dial">
          <ShieldCheckIcon className="h-7 w-7 text-aqua" aria-hidden="true" data-id="element-50" data-mp="jqpt4rvzl58h" />
          <span className="font-display text-sm font-extrabold text-navy" data-id="element-51" data-mp="nsb427oyn9g1">10 DAYS</span>
        </div>
        <div data-id="element-52" data-mp="slmaw8trvq7y">
          <h2 className="font-display text-2xl font-extrabold text-navy sm:text-3xl" data-id="element-53" data-mp="sn6ux4ignqrk">
            Take 10 Days to Explore the Pack
          </h2>
          <p className="mt-3 text-lg leading-relaxed text-ink" data-id="element-54" data-mp="12jti3zy9etwr">
            Read the guide, explore the worksheets, and decide whether the content is right for you.
            If you’re not satisfied, contact us within 10 days of purchase to request a refund.
          </p>
          <p className="mt-4 text-sm text-ink" data-id="element-55" data-mp="20t3t8o6yoqvn">
            Support:{' '}
            <a href={`mailto:${siteConfig.supportEmail}`} className="font-semibold text-navy underline decoration-aqua underline-offset-2" data-id="element-56" data-mp="20v6uy5hh88g7">
              {siteConfig.supportEmail}
            </a>
            <span className="mx-2 text-ink/40" data-id="element-57" data-mp="2oiy9lfqhoxkn">·</span>
            <a href={siteConfig.refundPolicyUrl} className="font-semibold text-navy underline decoration-aqua underline-offset-2" data-id="element-58" data-mp="2okizut5rtucp">
              Refund policy
            </a>
          </p>
        </div>
      </div>
    </section>;
}